export enum RecordStatus {
    Processing = 0,
    Available = 1,
    Unavailable = 1
}